var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.model)?_c('page-header',{attrs:{"title":_vm.title}}):_vm._e(),(_vm.model)?_c('price-config-form',{attrs:{"model":_vm.model}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }